module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-7.9ca74858.jpg";